import { ROUTE_PATH } from "common/constants/sm-constants";
import { FormMetaModel, SmMetaInputModel, SmBtnMetaModel } from "common/models/utility-models/meta-model";

export class UsersMetaModel extends FormMetaModel {
    constructor() {
        super('Add User', ROUTE_PATH.userGrid, ROUTE_PATH.addUser, 3, '', false, '', 'd-flex align-items-center justify-content-center');
    }

    override initProperties(): any {
        const formInfo = super.initProperties();
        const first_name = new SmMetaInputModel(
           'first_name',
            'first_name',
            'input',
            true,
            'col-12s',
            1,
            1,
            'First Name',
            'text',
            '[a-zA-Z][a-zA-Z ]+',
            false,
            true,
            true,
            false,
            100,
            1,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            '',
            { evalKey: '', evalParam: [] },
            false,
            [],
            false,
            '',
            null,
            false,
            false,
            false,
            "First name"
        )


        const last_name = new SmMetaInputModel(
            'last_name',
            'last_name',
            'input',
            true,
            'col-12 ',
            1,
            1,
            'Last Name',
            'text',
            '[a-zA-Z][a-zA-Z ]+',
            false,
            true,
            true,

            false,
            100,
            1,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            '',
            { evalKey: '', evalParam: [] },
            false,
            [],
            false,
            '',
            null,
            false,
            false,
            false,
            "Last name"
        );
        const email = new SmMetaInputModel(
            'email',
            'email',
            'input',
            true,
            'col-12',
            1,
            1,
            'Email ID',
            'email',
            '',
            false,
            true,
            true,
            false,
            100,
            1,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            '',
            { evalKey: '', evalParam: [] },
            false,
            [],
            false,
            '',
            null,
            false,
            false,
            false,
            "Email ID"
        );
        const buttons = {
            submit: new SmBtnMetaModel('SUBMIT', '', true, false, true, true),
            isFormControl: false
        };


        return {
            formInfo,
            buttons,
            first_name,
            last_name,
            email
        }
    }
}